import React, { useState } from 'react'
import layers from '../../data/layers'
import LayerItem from './layerItem'
import ElementList from './elementList'
import { ReactComponent as Close } from '../../icons/close.svg'
import { ReactComponent as Icon } from '../../icons/logo.svg'
import { ReactComponent as CornerIcon } from '../../icons/corner-blue.svg'

import styled, { css } from 'styled-components'

const Logo = styled.div`
  position: absolute;
  padding: 0rem;
  top: 0rem;
  width: 100%;
  text-align: center;
`

const LogoIcon = styled(Icon)`
  max-width: 122px;
  height: 122px;
`

const MenuContainer = styled.div`
  position: absolute;
  background: #072b3b;
  color: #fff;
  padding: 0px;
  text-align: left;
  z-index: 5000;
  top: 0px;
  left: 0px;
  width: 180px;
  min-height: 100vh;
  text-align: center;
  z-index: 11;
`

const MenuContainerMob = styled.div`
  position: fixed;
  background: #072b3b;
  color: #fff;
  padding: 0px;
  text-align: left;
  z-index: 5000;
  top: 0px;
  right: -210px;
  width: 200px;
  min-height: 100vh;
  text-align: center;
  z-index: 20;
  border-radius: 2em 0 0 0;
  transition: right 0.2s ease-in;
  ${props =>
    props.menu &&
    css`
      right: 0px;
      transition: right 0.4s ease-out;
    `};
`
const LList = styled.div`
  position: absolute;
  top: 5rem;
  width: 100%;
  left: 0rem;
  opacity: 1;
  ${props =>
    !props.mobile &&
    css`
      top: 9rem;
    `};
`
const LayerName = styled.div`
  position: absolute;
  top: 5rem;
  left: 1rem;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
  text-align: left;
  pointer-events: all;
  left: 1rem;
  ${props =>
    !props.mobile &&
    css`
      top: 10.5rem;
    `};
`
const Back = styled.a`
  position: absolute;
  font-size: 14px;
  line-height: 14px;
  font-weight: 700;
  color: #fff;
  border: 1px solid #fff;
  padding: 0.5rem;
  left: 1rem;
  top: 1.5rem;
  border-radius: 0.5rem;
  cursor: pointer
    ${props =>
      !props.mobile &&
      css`
        top: 7rem;
      `};
`

const CloseIcon = styled(Close)`
  position: absolute;
  width: 2rem;
  height: 2rem;
  fill: #fff;
  padding: 0.5rem;
  top: 1rem;
  right: 1rem;
  z-index: 21;
`

const LB = styled.div`
  pointer-events: all;
`

const Corner = styled(CornerIcon)`
  position: fixed;
  top: 0px;
  left: 180px;
  z-index: 30000;
  width: 48px;
  height: 48px;
`

const Menu = ({ urlTo, mobile, state, close }) => {
  const [base, setLevel] = useState(true)

  const LayerList = layers.map((l, i) => (
    <LayerItem
      key={'LaIt-' + i}
      item={l}
      isSelected={state.selected.layer === l.layer}
      nextLevel={() => setLevel(false)}
      urlTo={urlTo}
      mobile={mobile}
      close={close}
      id={i}
    />
  ))

  const LayerSel = layers.find(obj => obj.layer === state.selected.layer)

  const Content = (
    <>
      {mobile && <CloseIcon onClick={() => close()} />}
      {base ? (
        <LB>
          <LList mobile={mobile}>{LayerList} </LList>
        </LB>
      ) : (
        <LB>
          <Back onClick={() => setLevel(true)} mobile={mobile}>
            <span>All layers</span>
          </Back>
          <LayerName mobile={mobile}>{LayerSel.title}</LayerName>
          <ElementList item={LayerSel} urlTo={urlTo} close={close} sel={state.selected} show={!base} mobile={mobile} />
        </LB>
      )}
    </>
  )

  return mobile ? (
    <MenuContainerMob id="Navigation-Mobile" menu={state.menu}>
      {Content}
    </MenuContainerMob>
  ) : (
    <MenuContainer id="Navigation">
      <Logo>
        <a href="https://telxius.com">
          <LogoIcon />
        </a>
      </Logo>
      {Content}
      <Corner className="corner" />
    </MenuContainer>
  )
}

export default Menu
